export const POPUP_CONTENT = {
    'app_beta': {
        title: '«РечиСтарт» — бесплатный доступ',
        description: 'Оставьте имя и телефон — после обработки заявки пришлём инструкцию для тестовой Android-версии. На вопросы ответим по возможности.',
        btnText: 'Получить инструкцию'
    },
    telegram: {
        title: 'Telegram может быть недоступен в РФ',
        description: 'Чтобы мы точно получили ваше обращение, заполните короткую форму. Мы свяжемся с вами удобным способом и ответим на вопросы о бесплатной диагностике.',
        btnText: 'Записаться на диагностику'
    },
    whatsapp: {
        title: 'WhatsApp может быть недоступен в РФ',
        description: 'Чтобы мы точно получили ваше обращение, заполните короткую форму. Мы свяжемся с вами удобным способом и ответим на вопросы о бесплатной диагностике.',
        btnText: 'Записаться на диагностику'
    },
};